/**
 * Operator-chosen shell layout, persisted per browser.
 *
 * - `simple`   — algo-first: lifecycle sidebar + slim top bar.
 * - `terminal` — Kite-style trading workspace: top nav + More, live index
 *                strip, docked watchlist on the trading pages.
 *
 * Same pages, same routes, same permissions in both — only the chrome differs.
 * The shell mounts after the session store rehydrates (client-only), so
 * reading this synchronously never causes an SSR hydration mismatch.
 */
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export type LayoutMode = 'simple' | 'terminal';

interface LayoutModeState {
  mode: LayoutMode;
  setMode: (mode: LayoutMode) => void;
}

export const useLayoutModeStore = create<LayoutModeState>()(
  persist(
    (set) => ({
      mode: 'simple',
      setMode: (mode) => set({ mode }),
    }),
    { name: 'te:layout:v1', storage: createJSONStorage(() => localStorage) },
  ),
);

/** Where the brand/logo link goes in each layout. */
export const LAYOUT_HOME: Record<LayoutMode, string> = {
  simple: '/control',
  terminal: '/overview',
};
